import { COMMON  } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        breakConnection: COMMON.en.disconnect,
        connect: COMMON.en.addConnection,
        delete: COMMON.en.delete,
        manageEvidence: 'Manage Evidence',
        modify: 'Modify',
        newNode: 'Create & Connect a New Node'
    }
}

export default TRANSLATIONS